import smoothscroll from 'smoothscroll-polyfill';

import { isIE } from './utility';
import { CFG } from './config';

// main
import {
    AnchorScroll,
    Accordion,
    ScrollManager,
    ShareButton
} from './_main';

// home
import {
    OpeningAnimation,
    ImageParallax,
    ScrollBalloonClass,
    ScrollTriggerClass
} from './_home'

{
    smoothscroll.polyfill();

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domShareButton = document.querySelector('[data-js="share"]');
    if (domShareButton) new ShareButton(domShareButton);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if (domAnchorScroll) {
        domAnchorScroll.forEach(el => {
            new AnchorScroll(el);
        });
    }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        })
    }
}

{
    const domOpeningAnimation = document.querySelector('[data-js="opening"]');
    if (domOpeningAnimation) new OpeningAnimation(domOpeningAnimation);

    const domImageParallax = document.querySelectorAll('[data-js="parallax"]');
    if (domImageParallax) {
        [...domImageParallax].forEach(el => {
            new ImageParallax(el);  
        })
    }

    const domScrollBalloonClass = document.querySelectorAll('[data-balloon="sbc"]');
    if (domScrollBalloonClass) new ScrollBalloonClass(domScrollBalloonClass);  

    const domScrollTriggerClass = document.querySelectorAll('[data-trigger="stc"]');
    if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  
}
